import { useEffect, useState } from "react";
import {
  getOrders,
  acceptOrder,
} from "../services/order.service";
import OrderTable from "../components/order/OrderTable";
import OrderHeader from "../components/order/OrderHeader";
import OrderDetailsModal from "../components/order/OrderDetailsView";
import AssignDriverModal from "../components/order/AssignDriverModal";
import { useToast } from "../context/ToastContext";
import useOrderSocket from "../hooks/useOrderSocket";
import { useNavigate } from "react-router-dom";

export default function Orders() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ data: [], last_page: 1, total: 0 });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [selected, setSelected] = useState(null);
  const [assignTarget, setAssignTarget] = useState(null);

  useOrderSocket((payload) => {
    if (payload.action === "created" || payload.action === "updated") {
      loadOrders();
    }
  });

  useEffect(() => {
    loadOrders();
  }, [page, search, statusFilter, dateFilter, typeFilter]);

  async function loadOrders(isSilent = false) {
    if (!isSilent) setLoading(true); 
    
    try {
      const params = { page, search, status: statusFilter, date: dateFilter, type: typeFilter };
      const res = await getOrders(params);
      setData(res);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }

  

  async function handleAssign(order, driverId) {
    try {
      await acceptOrder(order.id, driverId);
      setAssignTarget(null);
      loadOrders();
      showToast("Chauffeur assigné", "success");
    } catch (error) {
      showToast("Erreur assignation", "error");
    }
  }

  if (loading && data.data.length === 0) {
    return <div className="loaderContainer">Chargement des commandes...</div>;
  }
  return (
    <div className="page">
      <OrderHeader
        total={data.total}
        search={search}
        onSearch={(v) => {
          setSearch(v);
          setPage(1);
        }}
        statusFilter={statusFilter}
        onStatusChange={(v) => {
          setStatusFilter(v);
          setPage(1);
        }}
        dateFilter={dateFilter}
        onDateChange={(v) => {
          setDateFilter(v);
          setPage(1);
        }}
        typeFilter={typeFilter}
        onTypeChange={(v) => {
          setTypeFilter(v);
          setPage(1);
        }}
      />

     <OrderTable
       orders={data.data}
        onView={(o) => navigate(`/rides/${o.id}`)} 
        onAssign={setAssignTarget}
      />

      <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"
            disabled={page === 1 || loading}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page || loading}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>

      <AssignDriverModal
        order={assignTarget}
        onAssign={handleAssign}
        onClose={() => setAssignTarget(null)}
      />
      <OrderDetailsModal order={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
